"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddCategoryBlock = exports.TitleHeader = void 0;
const react_1 = __importDefault(require("react"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const QButton_1 = __importDefault(require("components/QButton"));
const TitleHeader = ({ classes, dialogTitle, isMacDataset, create = false }) => {
    let subText;
    if (create) {
        if (isMacDataset) {
            subText = 'Here is a starter budget to get you going.  You can budget specific categories, ' +
                ' either from our suggestions list, or pick exactly the one to add from the full category list.';
        }
        else {
            subText = 'Here is a starter budget for you to fill out. You can enter just an income and expense amount, or you ' +
                'can budget specific categories, either from our suggestions list, or pick exactly the one to add from the ' +
                'full category list.';
        }
    }
    else {
        subText = 'This is your existing budget. You may choose to update the amount, add or remove categories.' +
            '  Changes you make will be automatically applied to the remaining months for the year.';
    }
    return (<div className={classes.header}>
      <Typography_1.default variant="h5" className={classes.title}>
        {dialogTitle}
      </Typography_1.default>
      <Typography_1.default style={{ paddingRight: 8 }} variant="body1">
        {subText}
      </Typography_1.default>
    </div>);
};
exports.TitleHeader = TitleHeader;
const AddCategoryBlock = ({ classes, onAddCategory, onSuggestedCategories }) => (<div className={classes.addCategoryBlock}>
    <QButton_1.default variant="contained" id="edit-budgets-suggested-categories" className={classes.addCategoryButton} aria-label="Show Suggested Categories" onClick={onSuggestedCategories} classes={{ conButton: classes.addButtonPrimary }}>
      <Add_1.default /> Suggestions
    </QButton_1.default>
    <QButton_1.default variant="contained" id="edit-budgets-add-category" className={classes.addCategoryButton} aria-label="Add Category" onClick={onAddCategory} classes={{ conButton: classes.addButtonSecondary }}>
      <Add_1.default /> Add Category
    </QButton_1.default>
  </div>);
exports.AddCategoryBlock = AddCategoryBlock;
